import { render, staticRenderFns } from "./Finance-bill.vue?vue&type=template&id=1ca2e52c&"
import script from "./Finance-bill.vue?vue&type=script&lang=js&"
export * from "./Finance-bill.vue?vue&type=script&lang=js&"
import style0 from "./Finance-bill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports